export default __webpack_public_path__ + "static/media/layout03.21e994a3.png";